import React from 'react'
import { RouteConfig } from 'react-router-config'
import { MerchantLayout } from 'views/layouts/Merchant'
import Merchant from 'views/screens/main/Merchant'

export const routes: RouteConfig[] = [

	//Root
	{ path: '/', exact: true, component: () => <Merchant /> },

	//Main views
	{
		route: '/', component: MerchantLayout as any, routes: [
			{ path: '/:merchant', exact: true, component: React.lazy(() => import('views/screens/main/Return')), },
			{ path: '/:merchant/confirm', exact: true, component: React.lazy(() => import('views/screens/main/ReturnConfirmation')), },
			{ component: React.lazy(() => import('views/screens/errors/Error404')) }
		]
	},
]
